export function sortBasedOnList(data, sortOrder: string[]) {
  const sortedKeys = Object.keys(data);

  sortedKeys.sort(function (x, y) {
    const xIndex = sortOrder.indexOf(x);
    const yIndex = sortOrder.indexOf(y);
    return xIndex > yIndex ? 1 : -1;
  });
  return sortedKeys;
}
